import { render, staticRenderFns } from "./FlashForm.vue?vue&type=template&id=920cb572&"
import script from "./FlashForm.vue?vue&type=script&lang=js&"
export * from "./FlashForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports